import { ComponentType } from 'react';
import { Step } from 'react-joyride';

import { ColorType } from '@deliveryhero/pd-cookbook/components/Styled/withColor/types';
import { ListItemButtonProps as MuiListItemButtonProps } from '@mui/material/ListItemButton';

import { AppRoute, AppRouteId } from 'share/types/routes';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  fill?: ColorType;
}

export interface ListItemButtonProps extends MuiListItemButtonProps {
  inset?: boolean;
}

export interface IconWrapperProps {
  tag: ComponentType<IconProps>;
  active: boolean;
}

export interface Props {
  /**
   * the width of navigation drawer
   */
  width: number;
  /**
   * what route to exclude
   */
  exclude?: AppRouteId[];
  /**
   * link/url to voucher shop
   */
  voucherShopUrl?: string;
  handleShowTour?: (show: boolean) => void;
  handleTourActive?: (run: boolean) => void;
  setSteps?: (steps: Step[]) => void;
  showTour?: boolean;
  isVerified?: boolean;
}

interface RouteCommon {
  id: AppRouteId;
  label: string;
  icon?: React.ComponentType<IconProps>;
  iconProps?: IconProps;
}

type RouteOption =
  | {
      path?: AppRoute | string;
      children?: never;
    }
  | {
      children?: RouteDef[];
      path?: never;
    };

export type RouteDef = RouteCommon & RouteOption;

export interface ListItemLinkProps {
  icon?: React.ComponentType<IconProps>;
  iconProps?: IconProps;
  label: string;
  to: string;
  selected?: boolean;
  mark?: boolean;
  inset?: boolean;
  fullPath?: boolean;
}

export enum Label {
  Vouchers = 'Vouchers'
}
